module.exports = __webpack_public_path__ + "static/img/1.4c0ded6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v16_new_features/1.png
// module id = bsVz
// module chunks = 0